import {PREV_URL_COOKIE} from './PREV_URL_COOKIE';

/** Stores list URL for the sourcing header back button (pathname + query, e.g. `?sort=`). */
export function rememberSourcingPrevUrl(location: {pathname: string; search: string}) {
  localStorage.setItem(PREV_URL_COOKIE, `${location.pathname}${location.search}`);
}
